import wixData from 'wix-data';
import wixAnimations from 'wix-animations';
import wixWindow from 'wix-window';
import { fireBIEvent } from 'public/bi-events.js';

// ...

let formFactor = wixWindow.formFactor;
let pauseQuotesOnload = false

const bi12001 = [{
        container: '#boxMainCta',
        ctaName: $w('#buttonMainCta').label,
        pageName: 'homepage',
        section: 'first_fold',
        targetUrl: $w('#buttonMainCta').link
    },
    {
        container: '#box148',
        ctaName: $w('#button43').label,
        pageName: 'homepage',
        section: 'second_fold',
        targetUrl: $w('#button43').link
    }
];

const bi12002 = [{
        container: '#box54',
        ctaName: $w('#button12').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text25').text,
        targetUrl: $w('#button12').link
    },
    {
        container: '#box111',
        ctaName: $w('#button29').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text60').text,
        targetUrl: $w('#button29').link
    },
    {
        container: '#box114',
        ctaName: $w('#button30').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text62').text,
        targetUrl: $w('#button30').link
    },
    {
        container: '#box117',
        ctaName: $w('#button31').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text64').text,
        targetUrl: $w('#button31').link
    },
    {
        container: '#box120',
        ctaName: $w('#button32').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text66').text,
        targetUrl: $w('#button32').link
    },
    {
        container: '#box123',
        ctaName: $w('#button33').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text68').text,
        targetUrl: $w('#button33').link
    },

]

const anchoreButtons = [{
        container: '#boxAnchorBtn1',
        ctaName: $w('#button28').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text58').text,
        targetUrl: '#box59'

    },
    {
        container: '#boxAnchorBtn2',
        ctaName: $w('#button34').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text58').text,
        targetUrl: $w('#button34').link
    },
    {
        container: '#boxAnchorBtn3',
        ctaName: $w('#button35').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text58').text,
        targetUrl: $w('#button35').link
    },
    {
        container: '#boxAnchorBtn4',
        ctaName: $w('#button36').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text58').text,
        targetUrl: $w('#button36').link
    },
    {
        container: '#boxAnchorBtn5',
        ctaName: $w('#button37').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text58').text,
        targetUrl: $w('#button37').link
    },
    {
        container: '#boxAnchorBtn6',
        ctaName: $w('#button38').label,
        pageName: 'homepage',
        section: 'fourth_fold',
        subSection: $w('#text58').text,
        targetUrl: $w('#button38').link
    },
]

$w.onReady(function () {
    arrowAnimation()
    fireCtaBiEvents();
    allFunctionsOnload()
    // if (formFactor !== "Mobile") {

    // }
});

const fireCtaBiEvents = () => {
    anchoreButtons.forEach((button) => {
        const {
            container,
            subSection,
            ctaName,
            pageName,
            section,
            targetUrl,
        } = button;
        $w(container).onClick(() => {
            const biFields = {
                ctaName,
                pageName,
                section,
                subSection,
                targetUrl
            }
            fireBIEvent(19, 12002, biFields);
        })
    })
    bi12001.forEach((cta) => {
        const {
            container,
            ctaName,
            pageName,
            section,
            targetUrl,
        } = cta;
        $w(container).onClick(() => {
            const biFields = {
                ctaName,
                pageName,
                section,
                targetUrl
            }
            fireBIEvent(19, 12001, biFields);
        })

    })
    bi12002.forEach((cta) => {
        const {
            container,
            subSection,
            ctaName,
            pageName,
            section,
            targetUrl,
        } = cta;
        $w(container).onClick(() => {
            const biFields = {
                ctaName,
                pageName,
                section,
                subSection,
                targetUrl
            }
            fireBIEvent(19, 12002, biFields);
        })

    })
}

function allFunctionsOnload() {
    scrollEffects()
    $w("#page1").onViewportEnter((event) => {
        if (!pauseQuotesOnload) {
            getQuotes()
            pauseQuotesOnload = true
        }
    });
}

function getQuotes() {
    console.log("getQuotes---function")
    let currentIndex = 0
    let quotesIntervalPlayBool = false
    let turnQuoteIntervalOff = false

    setTimeout(function () {
        turnQuoteIntervalOff = true
    }, 500000);

    let showQuote = {
        "duration": 700,
        "direction": "left"
    };
    let hideQuote = {
        "duration": 700,
        "direction": "right"
    };

    wixData.query("quotes")
        .ascending("sort")
        .find()
        .then((results) => {
            let quotesItems = results.items
            console.log(quotesItems)
            let quotesItemsLength = quotesItems.length
            let delayBetweenQuotes = 5000
            var quoteInterval

            function setQuote() {
                if (!turnQuoteIntervalOff) {
                    if (currentIndex < quotesItemsLength - 1) {
                        currentIndex++
                    } else {
                        currentIndex = 0
                    }
                    // console.log("currentIndex: " + currentIndex)
                    switchTexts()
                }

            }

            $w("#sectionAlt").onViewportEnter((event) => {
                if (!quotesIntervalPlayBool) {
                    quotesIntervalPlayBool = true
                    quoteInterval = setInterval(setQuote, delayBetweenQuotes);
                }
            });

            $w("#buttonNextQuote").onClick((event) => {
                if (currentIndex < quotesItemsLength - 1) {
                    currentIndex++
                } else {
                    currentIndex = 0
                }
                switchTexts()
            });

            $w("#buttonPrevQuote").onClick((event) => {
                if (currentIndex !== 0) {
                    currentIndex--
                } else {
                    currentIndex = quotesItemsLength - 1
                }
                switchTexts()
            });

            function switchTexts() {
                $w("#repeaterQuotes").forEachItem(($item, itemData, index) => {
                    if (index === currentIndex) {
                        $item("#boxSelection").style.backgroundColor = "#fff"
                    } else {
                        $item("#boxSelection").style.backgroundColor = "rgba(255, 255, 255, 0)"
                    }

                    $item("#boxItem").onClick((event) => {
                        if (index !== currentIndex) {
                            currentIndex = index
                            switchTexts()
                        }
                    });
                    $item("#boxItem").onMouseIn((event) => {
                        if (index !== currentIndex) {
                            $item("#boxSelection").style.backgroundColor = "#fff"
                        }
                    });
                    $item("#boxItem").onMouseOut((event) => {
                        if (index !== currentIndex) {
                            $item("#boxSelection").style.backgroundColor = "rgba(255, 255, 255, 0)"
                        }
                    });
                });

                if ($w("#textQuoteA").isVisible) {
                    $w("#textQuoteB").html = quotesItems[currentIndex].quote
                    $w("#textWebsiteOwner").html = quotesItems[currentIndex].websiteOwnerText
                    $w("#textWebsiteUrl").html = quotesItems[currentIndex].websiteOwnerUrl
                    $w("#textQuoteA").hide("float", hideQuote)
                    $w("#textQuoteB").show("float", showQuote)

                } else {
                    $w("#textQuoteA").html = quotesItems[currentIndex].quote
                    $w("#textWebsiteOwner").html = quotesItems[currentIndex].websiteOwnerText
                    $w("#textWebsiteUrl").html = quotesItems[currentIndex].websiteOwnerUrl
                    $w("#textQuoteB").hide("float", hideQuote)
                    $w("#textQuoteA").show("float", showQuote)
                }
            }

            $w("#boxAllQuotes").onMouseOut((event) => {
                if (!quotesIntervalPlayBool) {
                    quotesIntervalPlayBool = true
                    quoteInterval = setInterval(setQuote, delayBetweenQuotes);
                }
            });
            $w("#boxAllQuotes").onMouseIn((event) => {
                if (quotesIntervalPlayBool) {
                    quotesIntervalPlayBool = false
                    clearInterval(quoteInterval);
                }
            });

            $w("#repeaterQuotes").data = quotesItems
            $w("#repeaterQuotes").forEachItem(($item, itemData, index) => {
                if (index === 0) {
                    $item("#boxSelection").style.backgroundColor = "#fff"
                }
            });
        })
        .catch((err) => {
            let errorMsg = err;
        });
}

let yScroll
let timelineSpin = wixAnimations.timeline();

function scrollEffects() {
    if (formFactor !== "Mobile") {
        let yScrollStopCoorBool = false
        $w("#sectionScroll").onViewportEnter((event) => {
            yScrollStopCoorBool = true
        });
        $w("#sectionScroll").onViewportLeave((event) => {
            yScrollStopCoorBool = false
        });

        $w('#customElementScroll').on('coor', (event) => {
            if (yScrollStopCoorBool) {
                yScroll = event.detail.y
                const iconSpin = $w("#iconSpin");
                timelineSpin
                    .add(
                        iconSpin, {
                            "rotate": yScroll,
                            "duration": 10
                        }
                    )
                    .play();

            }
        });
    }

}


function arrowAnimation() {
    let timelineMainCta = wixAnimations.timeline();
    const boxMainCta = $w("#boxMainCta");

    $w("#buttonMainCta").onMouseIn((event) => {
        timelineMainCta
            .add(
                boxMainCta, {
                    "opacity": 0.85,
                    "duration": 200,
                    "easing": "easeInOutSine",

                },
            )
            .play();
    });
    $w("#buttonMainCta").onMouseOut((event) => {
        timelineMainCta.reverse()
    });
    let timelineHeaderAnimationArrow = wixAnimations.timeline({
        "repeat": -1,
        "yoyo": true
    });
    const mainCtaArrow = $w("#mainCtaArrow");

    timelineHeaderAnimationArrow
        .add(
            mainCtaArrow, {
                "x": 8,
                "duration": 600,
                "easing": "easeInOutSine",

            },
        )
        .play();

}